import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { HEATMAP_DAYS } from 'constants/heatmap';
import { bem } from 'helpers/class-name';

import { DayHourHeatmapTableHead } from './DayHourHeatmap.helpers';

import './DayHourHeatmap.scss';

const { element } = bem('day-hour-heatmap');

function DayHourHeatmapGrid({ className, dayHeaders, rows, renderCell, testId }) {
  return (
    <table className={classNames(element('table'), className)} data-testid={testId}>
      <DayHourHeatmapTableHead dayHeaders={dayHeaders} />
      <tbody>
        {rows.map(row => (
          <tr key={row.key || row.time}>
            <th scope="row">{row.time}</th>
            {HEATMAP_DAYS.map((dayKey, dayIndex) => (
              <td key={dayKey}>{renderCell(row, dayIndex, dayKey)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

DayHourHeatmapGrid.propTypes = {
  className: PropTypes.string,
  dayHeaders: PropTypes.arrayOf(PropTypes.node),
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.string.isRequired,
      key: PropTypes.string,
    })
  ).isRequired,
  renderCell: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

export default DayHourHeatmapGrid;
